import gql from 'graphql-tag'

export default gql`
  query CloudinaryGetAssetById($id: String!, $type: String!) {
    cloudinaryGetAssetById(id: $id, type: $type)
  }
`
